import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../graphql/GraphQlProvider';

export interface CreateCreditCardFeeInput {
    data: {
        fee: string | null
        type: number
        type_id?: number | null
    }
}

interface CreditCardFee {
    id: number;
    fee: string;
    type: number;
    type_id: number;
}

export const gqlCreditCardFee = `
    id,
    fee,
    type,
    type_id
`;

interface CreateCreditCardFeeData {
    __typename?: string,
    createCreditCardFee: CreditCardFee
}

export const CREATE_CREDIT_CARD_FEE_MUTATION = gql`
    mutation createCreditCardFee($data: CreateCreditCardFeeInput!){
        createCreditCardFee(data: $data){
            ${gqlCreditCardFee}
        }
    }
`;

export const createCreditCardFee = () => useMutation<CreateCreditCardFeeData, CreateCreditCardFeeInput>(
    CREATE_CREDIT_CARD_FEE_MUTATION,
    {
        update: updateCacheByType('CreditCardFee'),
    }
);

export default createCreditCardFee;
